import { Button } from "@/components/ui/button";
import React from "react";

interface TrialBannerProps {
  variant?: "default" | "fullWidth";
}

const TrialBanner = ({ variant = "default" }: TrialBannerProps) => {
  if (variant === "fullWidth") {
    return (
      <section className="py-16 md:py-20 lg:py-24 bg-dark -mb-0.5">
        <div className="mx-auto max-w-4xl px-5 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-[-0.02em] text-white mb-4 md:mb-6">
            Ready to know what's safe to spend?
          </h2>
          <p className="text-base md:text-lg text-white/70 mb-8 md:mb-10 leading-[1.6]">
            Start your 14-day free trial. No credit card required.
          </p>
          <Button
            variant="primary"
            size="lg"
            href="/signup"
            id="trial-banner-cta-fullwidth"
            className="h-12 px-7 text-[15px] font-semibold rounded-[14px]"
          >
            Start free trial
          </Button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 md:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="bg-gray-800 rounded-3xl p-10 md:p-16 lg:p-20">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-[-0.02em] text-white mb-6">
              Stop guessing what is safe to spend.
            </h2>
            <p className="text-lg md:text-xl text-white/70 mb-10 leading-[1.6]">
              Connect your business account and see your Safe-to-Spend number
              before your next VAT bill catches you out.
            </p>
            <Button
              variant="primary"
              size="lg"
              href="/signup"
              id="hero-cta-start-trial"
              className="h-12 px-7 text-[15px] font-semibold rounded-[14px]"
            >
              Start free trial
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrialBanner;
